let Accepted = function() {	
	return this.InvoicesList.filter((r) => r.status === 2);
};
export default Accepted;
